import React, { useContext, useEffect, useState } from "react";
import { Container, Img } from "./body.styles";
import QuestionText from "../QuestionText/QuestionText";
import ClosedQuestion from "../QuestionTypes/Closed/Closed";
import Slider from "../QuestionTypes/Slider/Slider";
import DropDown from "../QuestionTypes/DropDown/DropDown";
import Finish from "../QuestionTypes/Finish/Finish";
import AlreadyAnswered from "../AlreadyAnswered/AlreadyAnswered";
import CurrentQuestionContext from "../../contexts/CurrentQuestionContext";
import SurveyContext from "../../contexts/SurveyContext";
import Loader from "../Loader/Loader";
import {
  CLOSED_QUESTION,
  NUMBER_SLIDER,
  DROP_DOWN,
  FINISH,
} from "../../constants/questionTypes";
import LoadingGif from "./loading.gif";

const Body = () => {
  const questionType = useContext(CurrentQuestionContext).question.type;
  const title = useContext(CurrentQuestionContext).question.title;
  const imgUrl = useContext(CurrentQuestionContext).question.imgUrl;
  const isLoading = useContext(CurrentQuestionContext).isLoading;
  const isSuccessText = useContext(CurrentQuestionContext).isSuccessText;
  const questionText = useContext(CurrentQuestionContext).question.questionText;
  const isAlreadyAnswered = useContext(SurveyContext).isAlreadyAnswered;
  const [isNewComponent, setIsNewComponent] = useState(false);

  const getQuestionType = () => {
    switch (questionType) {
      case CLOSED_QUESTION:
        return <ClosedQuestion />;
      case NUMBER_SLIDER:
        return <Slider />;
      case DROP_DOWN:
        return <DropDown />;
      case FINISH:
        return <Finish />;
      default:
        return <img src={LoadingGif} style={{ height: "20vh" }} />;
    }
  };

  useEffect(() => {
    setIsNewComponent(!isNewComponent);
  }, [isSuccessText]);

  if (isAlreadyAnswered) {
    return (
      <Container
        isNewComponent={isNewComponent}
        isAlreadyAnswered={isAlreadyAnswered}
      >
        <div
          style={{
            width: "91%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Img src={imgUrl} />
          <br />
          <QuestionText text={title} isAlreadyAnswered={isAlreadyAnswered} />
          <AlreadyAnswered />
        </div>
      </Container>
    );
  } else {
    return (
      <Container isNewComponent={isNewComponent}>
        {!isSuccessText && (
          <div
            style={{
              width: "91%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <QuestionText text={questionText} />
            {!isSuccessText && getQuestionType()}
          </div>
        )}
        {isLoading && <Loader mounted={isLoading} />}
      </Container>
    );
  }
};

export default Body;
